<template>
  <div id="vip_noble" :class="isFull === 1 ? 'vip_noble1 top_information' : 'vip_noble1'">
    <van-nav-bar
        :title="$t('title.vip_title')"
        left-arrow
        placeholder
        @click-left="onClickLeft"
    >
     <template #right>
        <img src="../assets/img/vip/vip_switch_settings.png" class="vip_switch_settings" @click="jumpSwitchSettings" v-if="user_vip.svip_time"/>
      </template>
  </van-nav-bar>
    <van-row>
      <van-col span="24">
        <van-tabs class="vip_noble_tabs" v-model="active" swipeable>
          <van-tab v-for="item in list" :title="item.title" :key="item.vip_level">
            <van-col span="24" class="vip_noble_tabs_card">
              <img :src="item.icon"/>
            </van-col>
            <van-col span="24" class="vip_noble_tabs_bg">
              <van-col span="24" class="vip_noble_tabs_bg_title">
                <img src="../assets/img/vip/vip_noble_tabs_bg_title_l.png"/>
                  {{ $t('vip.exclusive_page') }}
                <img src="../assets/img/vip/vip_noble_tabs_bg_title_r.png"/>
              </van-col>
              <van-col span="22" offset="1">
                <van-col span="8" v-if="item.identity_url && item.identity_switch == 1">
                  <van-col span="20" offset="2" class="vip_noble_tabs_bg_content_type">
                    <img :src="item.identity_url"/>
                  </van-col>
                  <van-col span="20" offset="2" class="vip_noble_tabs_bg_content_type_name">
                    {{ $t('vip.vip_identity') }}
                  </van-col>
                </van-col>
                <van-col span="8" v-if="item.headwear_preview && item.headwear_switch == 1">
                  <van-col span="20" offset="2" class="vip_noble_tabs_bg_content_type">
                    <img :src="item.headwear_preview"/>
                  </van-col>
                  <van-col span="20" offset="2" class="vip_noble_tabs_bg_content_type_name">
                    {{ $t('vip.Exclusive_headwear')}}
                  </van-col>
                </van-col>
                <van-col span="8" v-if="item.entry_img_url && item.approach_switch == 1">
                  <van-col span="20" offset="2" class="vip_noble_tabs_bg_content_type">
                    <img :src="item.entry_img_url"/>
                  </van-col>
                  <van-col span="20" offset="2" class="vip_noble_tabs_bg_content_type_name">
                    {{ $t('vip.Entry_effects') }}
                  </van-col>
                </van-col>
                <van-col span="8" v-if="item.exclusive_page_image && item.exclusive_page_switch == 1">
                  <van-col span="20" offset="2" class="vip_noble_tabs_bg_content_type">
                    <img :src="item.exclusive_page_image"/>
                  </van-col>
                  <van-col span="20" offset="2" class="vip_noble_tabs_bg_content_type_name">
                    {{ $t('vip.exclusive_page')}}
                  </van-col>
                </van-col>
                <van-col span="8" v-if="item.bubble_url && item.bubble_switch == 1">
                  <van-col span="20" offset="2" class="vip_noble_tabs_bg_content_type">
                    <img :src="item.bubble_url"/>
                  </van-col>
                  <van-col span="20" offset="2" class="vip_noble_tabs_bg_content_type_name">
                    {{ $t('vip.Exclusive_bubble')}}
                  </van-col>
                </van-col>
                <van-col span="8" v-if="item.wave_url && item.wave_switch == 1">
                  <van-col span="20" offset="2" class="vip_noble_tabs_bg_content_type">
                    <img :src="item.wave_url"/>
                  </van-col>
                  <van-col span="20" offset="2" class="vip_noble_tabs_bg_content_type_name">
                    {{ $t('vip.exclusive_wave')}}
                  </van-col>
                </van-col>
              </van-col>
              <van-col span="24" class="vip_noble_tabs_bg_title">
                <img src="../assets/img/vip/vip_noble_tabs_bg_name_l.png"/>
                {{ $t('vip.more') }}
                <img src="../assets/img/vip/vip_noble_tabs_bg_name_r.png"/>
              </van-col>
              <van-col span="22" offset="1" class="vip_noble_bottom">
                <van-col span="8">
                  <van-col span="18" offset="3" :class="item.exclusive_nickname_switch == 1 ? 'vip_noble_tabs_type' : 'vip_noble_tabs_type vip_noble_tabs_type_lock' ">
                    <img :src="vip_privilege1"/>
                    <img :src="vip_lock" class="vip_noble_tabs_type_lock_img"/>
                  </van-col>
                  <van-col span="18" offset="3" class="vip_noble_tabs_bg_content_type_name"> {{ $t('vip.Exclusive_nickname') }}</van-col>
                </van-col>
                <van-col span="8">
                  <van-col span="18" offset="3" :class="item.daily_benefits_switch == 1 ? 'vip_noble_tabs_type' : 'vip_noble_tabs_type vip_noble_tabs_type_lock'">
                    <img :src="vip_privilege2"/>
                    <img :src="vip_lock" class="vip_noble_tabs_type_lock_img"/>
                  </van-col>
                  <van-col span="18" offset="3" class="vip_noble_tabs_bg_content_type_name"> {{ $t('vip.daily_benefts') }}</van-col>
                </van-col>
                <van-col span="8" v-if="svip_ranking_privileges_switch == 1">
                  <van-col span="18" offset="3" :class="item.rank_the_top == 1 ? 'vip_noble_tabs_type' : 'vip_noble_tabs_type vip_noble_tabs_type_lock'">
                    <img :src="vip_privilege3"/>
                    <img :src="vip_lock" class="vip_noble_tabs_type_lock_img"/>
                  </van-col>
                  <van-col span="18" offset="3" class="vip_noble_tabs_bg_content_type_name">{{ $t('vip.Rank_top') }} </van-col>
                </van-col>
                <van-col span="8">
                  <van-col span="18" offset="3" :class="item.view_visitors == 1 ? 'vip_noble_tabs_type' : 'vip_noble_tabs_type vip_noble_tabs_type_lock'">
                    <img :src="vip_privilege4"/>
                    <img :src="vip_lock" class="vip_noble_tabs_type_lock_img"/>
                  </van-col>
                  <van-col span="18" offset="3" class="vip_noble_tabs_bg_content_type_name">{{ $t('vip.View_visitors') }}</van-col>
                </van-col>
                <van-col span="8" v-if="svip_private_switch == 1">
                  <van-col span="18" offset="3" :class="item.any_private_chat == 1 ? 'vip_noble_tabs_type' : 'vip_noble_tabs_type vip_noble_tabs_type_lock'">
                    <img :src="vip_privilege5"/>
                    <img :src="vip_lock" class="vip_noble_tabs_type_lock_img"/>
                  </van-col>
                  <van-col span="18" offset="3" class="vip_noble_tabs_bg_content_type_name">{{ $t('vip.Any_private_chat') }}</van-col>
                </van-col>
                <van-col span="8">
                  <van-col span="18" offset="3" :class="item.shop_coin_switch == 1 ? 'vip_noble_tabs_type' : 'vip_noble_tabs_type vip_noble_tabs_type_lock'">
                    <img :src="vip_privilege6"/>
                    <img :src="vip_lock" class="vip_noble_tabs_type_lock_img"/>
                  </van-col>
                  <van-col span="18" offset="3" class="vip_noble_tabs_bg_content_type_name">{{ $t('vip.Mall_offers') }}</van-col>
                </van-col>
                <van-col span="8">
                  <van-col span="18" offset="3" :class="item.level_acceleration_switch == 1 ? 'vip_noble_tabs_type' : 'vip_noble_tabs_type vip_noble_tabs_type_lock'">
                    <img :src="vip_privilege7"/>
                    <img :src="vip_lock" class="vip_noble_tabs_type_lock_img"/>
                  </van-col>
                  <van-col span="18" offset="3" class="vip_noble_tabs_bg_content_type_name">{{ $t('vip.Level_acceleration') }}</van-col>
                </van-col>
                <van-col span="8">
                  <van-col span="18" offset="3" :class="item.fans_number_switch == 1 ? 'vip_noble_tabs_type' : 'vip_noble_tabs_type vip_noble_tabs_type_lock'">
                    <img :src="vip_privilege8"/>
                    <img :src="vip_lock" class="vip_noble_tabs_type_lock_img"/>
                  </van-col>
                  <van-col span="18" offset="3" class="vip_noble_tabs_bg_content_type_name">{{ $t('vip.Maximum_number_fans') }}</van-col>
                </van-col>
                <van-col span="8">
                  <van-col span="18" offset="3" :class="item.follows_limit_switch == 1 ? 'vip_noble_tabs_type' : 'vip_noble_tabs_type vip_noble_tabs_type_lock'">
                    <img :src="vip_privilege9"/>
                    <img :src="vip_lock" class="vip_noble_tabs_type_lock_img"/>
                  </van-col>
                  <van-col span="18" offset="3" class="vip_noble_tabs_bg_content_type_name">{{ $t('vip.Number_follows_limit') }}</van-col>
                </van-col>
                <van-col span="8" >
                  <van-col span="18" offset="3" :class="item.turn_on_incognito == 1 ? 'vip_noble_tabs_type' : 'vip_noble_tabs_type vip_noble_tabs_type_lock'">
                    <img :src="vip_privilege10"/>
                    <img :src="vip_lock" class="vip_noble_tabs_type_lock_img"/>
                  </van-col>
                  <van-col span="18" offset="3" class="vip_noble_tabs_bg_content_type_name">{{ $t('vip.Turn_on_incognito') }}</van-col>
                </van-col>
                <van-col span="8">
                  <van-col span="18" offset="3" :class="item.forbid_to_follow == 1 ? 'vip_noble_tabs_type' : 'vip_noble_tabs_type vip_noble_tabs_type_lock'">
                    <img :src="vip_privilege11"/>
                    <img :src="vip_lock" class="vip_noble_tabs_type_lock_img"/>
                  </van-col>
                  <van-col span="18" offset="3" class="vip_noble_tabs_bg_content_type_name">{{ $t('vip.Forbid_follow') }}</van-col>
                </van-col>
                <van-col span="8">
                  <van-col span="18" offset="3" :class="item.avoid_being_kicked == 1 ? 'vip_noble_tabs_type' : 'vip_noble_tabs_type vip_noble_tabs_type_lock'">
                    <img :src="vip_privilege12"/>
                    <img :src="vip_lock" class="vip_noble_tabs_type_lock_img"/>
                  </van-col>
                  <van-col span="18" offset="3" class="vip_noble_tabs_bg_content_type_name">{{ $t('vip.Avoid_being_kicked') }}</van-col>
                </van-col>
              </van-col>
            </van-col>
          </van-tab>
        </van-tabs>
      </van-col>
      <van-col span="24" class="vip_noble_pay" safe-area-inset-bottom>
        <van-col span="17" offset="1" v-if="list[active]">
          <van-col span="24" class="vip_noble_pay_upgrade">
            {{ $t('vip.Upgrade_recharge') }} <span>{{ list[active].coin }}</span> {{currency_name}} / {{ $t('other.month') }}
          </van-col>
           <van-col span="24" class="vip_noble_pay_relegation" v-if="user_vip.svip_level_id == list[active].vip_level && user_vip.svip_time">
            {{ $t('column.due_date') }}: {{ user_vip.svip_time }}
          </van-col>
        </van-col>
        <van-col span="5">
          <van-button class="vip_noble_pay_btn" size="small" color="linear-gradient(to right, #EBB689, #FFDEB3)" round block @click="user_vip_pay" v-if="!user_vip.svip_time"> {{ $t('btn.purchase') }}</van-button>
        </van-col>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import { Dialog, Toast } from 'vant'
export default {
  data:function() {
    return {
      list: [],
      active: 0,
      vip_privilege1: require('../assets/img/vip/vip_privilege1.png'),
      vip_privilege2: require('../assets/img/vip/vip_privilege2.png'),
      vip_privilege3: require('../assets/img/vip/vip_privilege3.png'),
      vip_privilege4: require('../assets/img/vip/vip_privilege4.png'),
      vip_privilege5: require('../assets/img/vip/vip_privilege5.png'),
      vip_privilege6: require('../assets/img/vip/vip_privilege6.png'),
      vip_privilege7: require('../assets/img/vip/vip_privilege7.png'),
      vip_privilege8: require('../assets/img/vip/vip_privilege8.png'),
      vip_privilege9: require('../assets/img/vip/vip_privilege9.png'),
      vip_privilege10: require('../assets/img/vip/vip_privilege10.png'),
      vip_privilege11: require('../assets/img/vip/vip_privilege11.png'),
      vip_privilege12: require('../assets/img/vip/vip_privilege12.png'),
      vip_lock: require('../assets/img/vip/vip_lock.png'),
      user_vip: {
         "svip_level_id": 0,
          "svip_time": 0
      },
      currency_name: undefined,
      svip_private_switch: 0,
      svip_ranking_privileges_switch: 0,
      isFull: 0 // is_full=1 全屏显示信号栏 0 非全屏显示信号栏
    }
  },
  created: function() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
    this.get_list()
  },
  methods: {
    jumpSwitchSettings(){
      // 拦截跳转到开关设置
      window.location.href="live://live?action=JumpSwitchSettings"
    },
    onClickLeft() {
      // 拦截返回app
      window.location.href="bogolive://exit"
    },
    user_vip_pay(){
      const pay = this.list[this.active]
      console.log(pay)
      let coin = pay.coin
      if (pay.vip_level === this.user_vip.vip_id) {
        coin = pay.renew_coin
      }
      const uid = this.$route.query.uid;
      const token = this.$route.query.token;
      Dialog.confirm({
        message: this.$t('vip.is_payment_diamonds',{coin: '<span style="color: #F9934A">' + coin +' ' + this.currency_name + '</span>'}),
        cancelButtonText: this.$t('btn.cancel'),
        confirmButtonText: this.$t('btn.confirm'),
        closeOnClickOverlay: true
      }).then(() => {
        // on confirm
        const loadings = Toast.loading({
          message: this.$t('other.Loading'),
          forbidClick: true,
          duration: 0, // 持续展示 toast
        });
       axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=svip&act=pay", { 
         params:{ uid:uid,token:token, id:pay.vip_level }
        }).then(res =>{
          loadings.clear()
          if(res.data.status===1){
            Toast.success({ message: res.data.error, duration: 1000 })
            setTimeout(() => {
              //需要定时执行的代码
              this.get_list()
            }, 2000)
          }else{
            Toast.fail(res.data.error)
          }
        })
      }).catch(() => {
        // on cancel
      })
    },
    get_list(){
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      const loadings = Toast.loading({
        message: this.$t('other.Loading'),
        forbidClick: true,
        duration: 0, // 持续展示 toast
      });
       axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=svip&act=index", { 
        params:{
           uid:uid,token:token
         }
      }).then(res =>{
        loadings.clear()
        if(res.data.status ===1){
          this.list = res.data.data.list
          this.currency_name = res.data.data.diamonds_name
          this.user_vip = res.data.data.user_info
          this.svip_private_switch = res.data.data.svip_private_switch
          this.svip_ranking_privileges_switch = res.data.data.svip_ranking_privileges_switch
        }else{
          Toast.fail(res.data.error);
        }
      })
    }
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/vip_noble.vue